import { RouteObject } from 'react-router-dom';

import { BubbleError, MainLayout } from '@/components';

import { notFoundRoute } from './not-found-route';
import {
  creditsRoute,
  dashboardRoutes,
  experiencesRoute,
  settingsRoute,
  usersRoute,
} from '@/features';

export const mainRoute: RouteObject = {
  element: <MainLayout />,
  children: [
    usersRoute,
    dashboardRoutes,
    experiencesRoute,
    creditsRoute,
    settingsRoute,
  ],
  errorElement: <BubbleError />,
};
